import { render } from "./NewJobsTableShiftSlot.vue?vue&type=template&id=2262a88a"
import script from "./NewJobsTableShiftSlot.vue?vue&type=script&lang=js"
export * from "./NewJobsTableShiftSlot.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__